import type { ReactNode } from "react";
import { tokens } from "@core/theme/tokens";

// PA-025-E (agent-logs/runs/2026-09-09-spec-211-portal/evidence/
// human-resolution-pa-025-e-duplication.json): el contenedor de la barra de
// filtros (buscador + selects + botón "Nuevo…") de BenefitsScreen.tsx y
// RewardsScreen.tsx compartía exactamente el mismo estilo. Extracción sin
// cambio de comportamiento ni de valores visuales.
export function FilterBar({ children }: { children: ReactNode }) {
  return (
    <div
      style={{
        border: `1px solid ${tokens.surface.line}`,
        borderRadius: 18,
        background: tokens.surface.bg2,
        padding: 14,
        marginBottom: 18,
        display: "flex",
        alignItems: "center",
        gap: 12,
        flexWrap: "wrap",
      }}
    >
      {children}
    </div>
  );
}
